// Roles internas da Amerinode.
//
// Durante muito tempo 'user' era a única role interna, então o código todo
// perguntava `user.role === 'user'` para dizer "é alguém da Amerinode operando
// o sistema". Com a entrada de 'admin' essa pergunta deixou de ser sobre uma
// role específica: um admin é um operador interno com MAIS privilégio, não
// menos, e precisa passar em todas as checagens em que o 'user' passa.
//
// Por isso as telas usam `ehUsuarioInterno(user)` em vez de comparar a role na
// mão — adicionar outra role interna no futuro passa a ser mudança de uma linha.
const ROLES_INTERNAS = ['user', 'admin'];

export function ehUsuarioInterno(user) {
    return ROLES_INTERNAS.includes(user?.role);
}

// Só o admin enxerga o menu de administração (Admin, Documentação).
export function ehAdmin(user) {
    return user?.role === 'admin';
}

// Quem pode administrar usuários — trocar role, resetar senha, trocar empresa,
// ativar/desativar e importar em massa.
//
// A lista é fechada por e-mail de propósito, e não por role: a tela permite
// mudar a role de qualquer um (inclusive se promover a admin) e resetar senha
// de qualquer um, então liberar por `role === 'user'` daria isso a toda a
// operação interna. Fica aqui, e não dentro de um sidebar, porque os menus de
// admin e de usuário mostram o mesmo item.
const EMAILS_GESTAO_USUARIOS = [
    'junior.silva@amerinode.com.br',
    'guilherme.alberto@amerinode.com.br',
    'maria.castro@amerinode.com.br',
];

export function podeGerenciarUsuarios(user) {
    return EMAILS_GESTAO_USUARIOS.includes(String(user?.email || '').toLowerCase());
}

const Roles = { ehUsuarioInterno, ehAdmin, podeGerenciarUsuarios, ROLES_INTERNAS };

export default Roles;
